import { NotificationStatus } from '../../../types';
import { NotificationUpdateResponse, updateNotificationStatus } from '../client/updateNotification';
import { NotificationResolveResponse, resolveNotification } from '../client/resolveNotification';

async function performStatusUpdate(
  userNotificationId: number,
  currentStatus: NotificationStatus,
  nextStatus: NotificationStatus,
): Promise<NotificationUpdateResponse> {
  const result = await updateNotificationStatus(userNotificationId, currentStatus, nextStatus);

  if (!result.success) {
    throw new Error(result.error ?? `Failed to update notification to ${nextStatus}`);
  }

  return result;
}

async function performResolveAction(
  actionName: string,
  request: Promise<NotificationResolveResponse>,
) {
  const result = await request;

  if (!result.success) {
    throw new Error(result.error ?? `Failed to ${actionName}`);
  }
}

export const markAsAccepted = (userNotificationId: number, currentStatus: NotificationStatus) =>
  performStatusUpdate(userNotificationId, currentStatus, 'ACCEPTED');

export const markAsRejected = (userNotificationId: number, currentStatus: NotificationStatus) =>
  performStatusUpdate(userNotificationId, currentStatus, 'REJECTED');

export const markAsRead = (userNotificationId: number, currentStatus: NotificationStatus) =>
  performStatusUpdate(userNotificationId, currentStatus, 'READ');

export const markAsUnread = (userNotificationId: number, currentStatus: NotificationStatus) =>
  performStatusUpdate(userNotificationId, currentStatus, 'UNREAD');

export const markNotificationAsResolved = (notificationMasterId: number) =>
  performResolveAction('resolve notification', resolveNotification(notificationMasterId));
